export default {"src":"/_next/static/media/TwitterRounded.1af36e64.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};